/**
 * Formatea un RUT para mostrar con puntos separadores de miles
 * Ejemplo: "9852196-8" -> "9.852.196-8"
 * Ejemplo: "9.852.196-8" -> "9.852.196-8" (ya formateado)
 * Ejemplo: "98521968" -> "9.852.196-8"
 * 
 * @param {string} rut - RUT sin formato o con formato
 * @returns {string} RUT formateado con puntos
 */
export const formatRut = (rut) => {
    if (!rut) return '';
    
    // Remover puntos y espacios existentes
    let cleaned = rut.toString().replace(/\./g, '').replace(/\s/g, '');
    
    // Separar número y dígito verificador
    let parts = cleaned.split('-');
    let numero = parts[0];
    let dv = parts[1] || '';
    
    // Si no hay guión, asumir que el último carácter es el dígito verificador
    if (parts.length === 1 && numero.length > 1) {
        dv = numero.slice(-1);
        numero = numero.slice(0, -1);
    }
    
    // Formatear el número con puntos (separador de miles)
    let formatted = numero.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    
    // Retornar con guión y dígito verificador
    return dv ? `${formatted}-${dv}` : formatted;
};

/**
 * Normaliza un RUT para búsqueda o comparación
 * Remueve puntos y convierte a minúsculas
 * Ejemplo: "9.852.196-8" -> "9852196-8"
 * 
 * @param {string} rut - RUT con o sin formato
 * @returns {string} RUT normalizado sin puntos
 */
export const normalizeRut = (rut) => {
    if (!rut) return '';
    return rut.toString()
        .replace(/\./g, '')
        .replace(/\s/g, '')
        .trim()
        .toLowerCase();
};
